var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/v2/forms/TextField';
import classnames from 'classnames';
export default function InputWithLeadingIcon(_a) {
    var { className, children, dataTestId } = _a, props = __rest(_a, ["className", "children", "dataTestId"]);
    return ((React.createElement("div", { "data-testid": dataTestId, className: classnames('relative rounded-md shadow-sm', className) },
        React.createElement("div", { "data-testid": "div-12aaca86", className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, children),
        React.createElement(TextField, Object.assign({ dataTestId: "TextField-723510d7" }, props, { className: "pl-10" })))));
}
InputWithLeadingIcon.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    children: PropTypes.node.isRequired,
};
